import React from "react";
import { Grid, Typography } from "@mui/material";
import unauthorized from "../../assets/images/Access-denied.svg";

export default function AccessDeniedPage() {
  return (
    <Grid container spacing={1} lg={12} md={12} xs={12}>
      <Grid item lg={6} md={6} xs={6} className="m-auto text-center">
        <Typography sx={{ mt: 16 }}>
          <img src={unauthorized} alt="Unauthorized" />
          <Typography className="mt-10 f-24 font-weight-700 light-text">
            Access Denied
          </Typography>
          <Typography className="mt-30 mb-70 f-16 font-weight-600 light-text">
            You don&apos;t have permission to view this page using the credential
            you have supplied.
          </Typography>
        </Typography>
      </Grid>
    </Grid>
  );
}
